import get from 'lodash/get';
import {
    GET_LANDING_TOP_BAR_DATA,
    GET_LANDING_TOP_BAR_DATA_SUCCESS,
    GET_LANDING_TOP_BAR_DATA_FAILURE,
} from '../../actions/landingPage/constants';

const INITIAL_STATE = {
  fetching: false,
  data: [],
};

export default function topBar(state = INITIAL_STATE, action) {
  switch (action.type) {
    case GET_LANDING_TOP_BAR_DATA:
      return {
        ...state,
        fetching: true,
      };
    case GET_LANDING_TOP_BAR_DATA_SUCCESS:
      return {
        ...state,
        fetching: false,
        data: get(action, 'payload.data', []),
      };
    case GET_LANDING_TOP_BAR_DATA_FAILURE:
      return {
        ...state,
        fetching: false,
        error: true,
        errorMsg: action.error,
      };

    default:
      return state;
  }
}
